const market = {
    dsbz: "Listelenmemiş Tokenlar",
    kpsj: "Açılış Geri Sayımı/Açılış Zamanı",
    ykp: "İşleme Açıldı",
    kpdjs: "Açılış Geri Sayımı",
    worning: "Nihai işlem birim fiyatı değildir, sadece referans içindir",
    swapTab_1: "USDT Bazlı Kontrat",
    swapTab_2: "Coin Bazlı Kontrat",
    searchCoin: "İstediğiniz tokenı arayın",
    risk: "Risk Uyarısı",
    addSelfCode: "Favorilere Ekle",
    pair: "Parite",
    latestPrice: "Son Fiyat",
    changeHour: "24s Değişim",
    highHour: "24s Yüksek",
    lowHour: "24s Düşük",
    priceTrend: "Fiyat Trendi (3 Gün)",
    volumeHour: "24s İşlem Hacmi",
    noSearch: "Aranan token bulunamadı",
    noAdd: "Henüz favori eklenmedi",
    noYet: "Bu token henüz listelenmedi",
    noBi: "Henüz listelenmemiş tokenlar",
    wan: "B",
    qian: "K",
    yi: "M",
    yxhy: "Sürekli Kontrat",
    wghy: "Grid Kontrat",
    cxjy: "İnovasyon Bölgesi'ndeki tokenlar genellikle teknoloji ve pazar açısından belirli başarılara sahiptir, ancak fiyat dalgalanmaları daha büyük ve riskler nispeten daha yüksektir. Lütfen ilgili bilgileri dikkatlice inceleyin ve kendi risk toleransınız dahilinde katılıp katılmayacağınıza karar verin.",
    qljy: "Potansiyel İşlem Bölgesi henüz pazar gelişiminin erken aşamasındadır, BiKing bunların değer mutabakatı ve pazar likiditesi hakkında herhangi bir garanti veremez. Lütfen proje bilgilerini dikkatle gözden geçirin ve kendi risk toleransınız dahilinde yatırım yapın.",
    qljyDao: "DAO İşlem Bölgesi henüz pazar gelişiminin erken aşamasındadır, BiKing bunların değer mutabakatı ve pazar likiditesi hakkında herhangi bir garanti veremez. Lütfen proje bilgilerini dikkatle gözden geçirin ve kendi risk toleransınız dahilinde yatırım yapın.",
    default: "İşlem Bölgesi henüz pazar gelişiminin erken aşamasındadır, BiKing bunların değer mutabakatı ve pazar likiditesi hakkında herhangi bir garanti veremez. Lütfen proje bilgilerini dikkatle gözden geçirin ve kendi risk toleransınız dahilinde yatırım yapın.",
    storage: "Depolama İşlem Bölgesi henüz pazar gelişiminin erken aşamasındadır, BiKing bunların değer mutabakatı ve pazar likiditesi hakkında herhangi bir garanti veremez. Lütfen proje bilgilerini dikkatle gözden geçirin ve kendi risk toleransınız dahilinde yatırım yapın.",
    dlt: "Düşük Likidite Bölgesi'ndeki dijital varlıkların pazar likiditesi düşüktür ve listeden çıkarılma riski taşır. Yatırım yapmadan önce dikkatle değerlendirme yapmanız önerilir.",
    defi: "DEFI İşlem Bölgesi henüz pazar gelişiminin erken aşamasındadır, BiKing bunların değer mutabakatı ve pazar likiditesi hakkında herhangi bir garanti veremez. Lütfen proje bilgilerini dikkatle gözden geçirin ve kendi risk toleransınız dahilinde yatırım yapın.",
    nft: "NFT İşlem Bölgesi henüz pazar gelişiminin erken aşamasındadır, BiKing bunların değer mutabakatı ve pazar likiditesi hakkında herhangi bir garanti veremez. Lütfen proje bilgilerini dikkatle gözden geçirin ve kendi risk toleransınız dahilinde yatırım yapın.",
    hz: "Sürekli",
    yx: "Araştırma Seçimi",
    yjyzx: "Araştırma Enstitüsü Seçilmiş Projeler",
    zx: "Favoriler",
    bb: "Spot",
    hy: "Kontrat",
    zfb: "Yükselenler",
    xbb: "Yeni Tokenlar",
    bd: "Parite",
    zxj: "Son Fiyat",
    zdf24: "24s Değişim",
    high24: "24s Yüksek",
    low24: "24s Düşük",
    turnover24: "24s İşlem Hacmi",
    zd24: "24s Değişim",
    zjrzd: "Fiyat/Günlük Değişim",
    scgl: "Pazar Genel Görünüm",
    jysj: "İşlem Verileri",
    fyje: "Komisyon Miktarı",
    ms: "Evet",
    mf: "Hayır",
    "是否交易": "İşlem Yapıldı mı",
    "推荐好友": "Arkadaş Öner",
    "推荐": "Öner",
    "合约交易返佣": "Yüksek Kontrat İşlem Komisyonu Kazanın",
    "我的返佣比例": "Benim Komisyon Oranım",
    "好友返佣比例": "Arkadaş Komisyon Oranı",
    "推荐码": "Öneri Kodu",
    "交易人数": "İşlem Yapan Kişi Sayısı",
    "推荐总览": "Öneri Genel Bakış",
    "推荐人数": "Önerilen Kişi Sayısı",
    "推荐链接": "Öneri Bağlantısı",
    "一键分享": "Tek Tıkla Paylaş",
    "合约返佣": "Toplam Kontrat Komisyonu",
    "推荐记录": "Öneri Kaydı",
    "返佣记录": "Komisyon Kaydı",
    "推荐好友": "Arkadaş Öner",
    "请输入账户UID": "Lütfen Hesap UID'sini girin",
    "账户UID": "Hesap UID",
    "注册时间": "Kayıt Zamanı (UTC+8)",
    "合约手续费": "Kontrat İşlem Ücreti",
    "返佣活动规则说明": "Komisyon Etkinlik Kural Açıklaması:",
    "使用你的推荐链接": "Sizin öneri bağlantınızı veya öneri kodunuzu kullanarak kaydolan kullanıcılar sizin davetliniz sayılır; eğer kullanıcı kayıt sırasında öneri kodunu doldurmadıysa, davet ilişkisi kurulmaz;",
    "被邀请人产生的真实交易手续费": "Davetlinin oluşturduğu gerçek işlem ücretleri üzerinden, davet eden kişi işlem ücretine karşılık gelen oranda komisyon kazanır, ertesi gün davet edenin hesabına yansıtılır, spesifik hesaba geçiş zamanı her gün 04:00'dan sonra olacaktır;",
    "用户邀请朋友无上限": "Kullanıcıların arkadaş davet etme limiti yoktur, davetlilerin sadece kontrat işlemleri için ödediği ücretler komisyona dahil edilir;",
    "被邀请人只有进行合约": "Davetlilerin sadece kontrat işlemleri için ödediği ücretler komisyona dahil edilir;",
    "不允许任何用户通过多": "Herhangi bir kullanıcının birden fazla hesap aracılığıyla kendi kendini davet etmesine izin verilmez, tespit edilmesi durumunda tüm komisyonlar iptal edilecek ve davet edilen hesapların işlem ücreti komisyonları da iptal edilecektir",
    "由于市场环境的改变": "Pazar koşullarındaki değişiklikler, dolandırıcılık risklerinin varlığı vb. nedenlerle, Biking komisyon kurallarını istediği zaman ayarlama hakkını saklı tutar.",
    "保留对活动的最终解释权": "Herhangi bir sorunuz varsa, lütfen müşteri hizmetleriyle iletişime geçin."
};

export { market };


// WEBPACK FOOTER //
// ./src/i18n/lang/market/tr.js